import "./JournalEntry.css";
import React, { useState, useRef, useEffect, useContext } from "react";
import "../../Master/SchemeRegistration/SchemeRegistration.css";
import "../SchemeReceipt/SchemeCashReceipt.css";
import headeLogo from "../../../assets/images/shersoftnavLogo.png";
import close from "../../../assets/images/findclose.png";
import ComboBox from "../../ComboBoxes/ComboBox";
import axios from "axios";
import Print from "../../PrintModels/Print";
import io from 'socket.io-client';
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../../components/NavBars/ActionToolbar";
import GridDesign from "../../GridDesign/GridDesign";
import FormDesign, { FormDesignProvider, useFormDesign } from "../../FormDesign/FormDesign";
import { createGridKeyDownHandler } from "../../../utils/gridKeyDownHelper";



import { selectActiveFyid } from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";

function JournalEntryInner(props) {
  const { onClose, Open, zIndex } = props;
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { agentCode } = useContext(AuthContext);
  const { dbCode } = useDbContext();
  const permissions = useSelector(selectMenuPermissions);
  const activeLocation = useSelector(selectActiveLocation);
  const [locationOptions, setLocationOptions] = useState([]);

  const storedLocId = sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId");
  const storedLocName = sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation");

  const getDefaultBranch = () => {
    if (activeLocation?.id) return [Number(activeLocation.id), activeLocation.name];
    if (storedLocId) return [Number(storedLocId), storedLocName || "SHOP"];
    return [0, "SHOP"];
  };

  const activeFyid = useSelector(selectActiveFyid);
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;



  const agentCodeRef = useRef(agentCode);

  useEffect(() => {
    agentCodeRef.current = agentCode;
  }, [agentCode]);

  const [showPrintModel, setShowPrintModel] = useState(false);

  const [printData, setPrintData] = useState(null);

  const handleClosePrint = () => {
    setShowPrintModel(false);
  };
  const [startDate, setStartDate] = useState(new Date());
  /////////////table///////////
  const tableContainerRef = useRef(null);
  const cashaccref = useRef(null);

  const entryNoInputRef = useRef(null);
  const branchinputRef = useRef(null);
  const salesmaninputRef = useRef(null);

  const rateInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const saveButtonRef = useRef(null);
  const editButtonRef = useRef(null);

  const addRow = () => {
    // //////////////////console.log("add row called");
    setTableData([...tableData, {}]);
  };

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [showGridDesignModal, setShowGridDesignModal] = useState(false);
  const [showFormDesignModal, setShowFormDesignModal] = useState(false);

  // ── FormDesign hook ──
  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
    setFields: setFormFields,
    activeFieldId,
    rowBreakColumn,
    rowBreakTarget,
    breakoutColumn,
    setRowBreakColumn,
    setRowBreakTarget,
    setBreakoutColumn,
    setBreakoutTarget,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  const defaultJournalGridColumns = [
    {
      sNo: 1,
      columnName: "debitAccount",
      width: 200,
      orderNo: 0,
      header: "Select Debit Account",
      show: true,
    },
    {
      sNo: 2,
      columnName: "creditAccount",
      width: 200,
      orderNo: 1,
      header: "Select Credit Account",
      show: true,
    },
    {
      sNo: 3,
      columnName: "amount",
      width: 200,
      orderNo: 2,
      header: "Amount",
      show: true,
    },
    {
      sNo: 4,
      columnName: "narration",
      width: 138,
      orderNo: 3,
      header: "Narration",
      show: true,
    },
  ];

  const [gridColumns, setGridColumns] = useState(defaultJournalGridColumns);
  const vType = props.voucherType || props.formName || "JOURNAL";

  useEffect(() => {
    const loadGridSettings = async () => {
      if (!dbCode || !vType) return;
      let cached = localStorage.getItem(`grid_design_${vType}`);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          setGridColumns(parsed);
          return;
        } catch (e) {
          console.error("Error parsing cached grid settings:", e);
        }
      }

      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/griddesign/${dbCode}/${vType}`,
        );
        const dbCols = response.data.recordset || response.data || [];
        if (dbCols.length > 0) {
          const merged = defaultJournalGridColumns.map((initCol) => {
            const dbMatch = dbCols.find(
              (c) =>
                String(c.ColName).toLowerCase() ===
                String(initCol.columnName).toLowerCase(),
            );
            if (dbMatch) {
              return {
                ...initCol,
                width: dbMatch.Width !== null ? dbMatch.Width : initCol.width,
                orderNo: dbMatch.InNo !== null ? dbMatch.InNo : initCol.orderNo,
                header: dbMatch.Header || initCol.header,
                show: dbMatch.Vis === 1,
              };
            }
            return initCol;
          });
          merged.sort((a, b) => a.orderNo - b.orderNo);
          localStorage.setItem(`grid_design_${vType}`, JSON.stringify(merged));
          setGridColumns(merged);
        }
      } catch (error) {
        console.error("Error loading grid settings:", error);
      }
    };
    loadGridSettings();
  }, [dbCode, apiBaseUrl, vType]);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const dropdownRef = useRef(null);

  // const handleScroll = () => {
  //   const tableContainer = tableContainerRef.current;
  //   if (
  //     tableContainer.scrollTop + tableContainer.clientHeight >=
  //     tableContainer.scrollHeight - 1
  //   ) {
  //     // User has scrolled to the bottom, add new rows
  //     addRow();
  //   }
  // };

  const { minDate, maxDate, isDateInFy } = useActiveFyLimits();

  //////////current date///////////

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to minDate/maxDate of active FY
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  const initialDateVal = getCurrentDate();

  ////////////////////////// form data states //////////

  const [tableData, setTableData] = useState([
    ...Array(14).fill({
      SINo: "",
      debitAccount: "",
      creditAccount: "",
      amount: "",
      narration: "",
    }),
  ]);

  const openPrintModal = () => {
    fetchData();
    const slnoLimit = handleCheckSlno();
    if (selectedSlNo > slnoLimit || selectedSlNo <= 0) {
      alert("Enter SlNo Correctly");
      return;
    }

    setPrintData({
      tableData: tableData,
      jvInfoData: jvInfoData,
      index: selectedSlNo,
    });
    setShowPrintModel(true);
  };
  // //////////////////console.log("table data ===== ", tableData);

  const [jvInfoData, setJvInfoData] = useState({
    EntryNo: "",
    Location: getDefaultBranch(),
    Salesman: "",
    date: initialDateVal,
    totalamt: "",
  });

  //  //////////////////console.log("info data = ", jvInfoData);

  ///////////////////////////////////////////////
  // const[accountTransaction,setAccountTransaction]=useState({

  // atDate:"",
  // atLedcode:"",
  // atType:"",
  // atEntryNo:"",
  // atAmount:"",
  // atNarration:"",

  //})

  ///////////////////////////////////////////////

  const handleCellChange = (event, rowIndex, field) => {
    const newData = [...tableData]; // Create a copy of the tableData array
    newData[rowIndex] = { ...newData[rowIndex], [field]: event }; // Update the value of the specified field in the row
    setTableData(newData); // Update the tableData state with the modified data
  };


  const handleCellChangeinput = (event, rowIndex, field) => {
    const newData = [...tableData]; // Create a copy of the tableData array

    if (field === "printgm") {
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: event.target.checked ? 1 : 0, // If checkbox is checked, set value to 1, otherwise 0
      };
    } else {
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: event.target.value,
      }; // Update the value of the specified field in the row
    }
    newData[rowIndex] = { ...newData[rowIndex], SINo: rowIndex + 1 }; // Update the SINo for the row
    setTableData(newData); // Update the tableData state with the modified data
  };



  const handleKeyDown = (event, nextInputRef) => {
    if (event.key === "Enter" || event.key === "Return") {
      nextInputRef.current.focus();
    }
  };
  const [RowIndex, setRowIndex] = useState(0);

  const backtrackfocus = () => {
    const rowIndex = sessionStorage.getItem('journalEntryRowIndex');
    const columnIndex = sessionStorage.getItem('journalEntryColumnIndex');

    const tableContainer = tableContainerRef.current;
    const rows = tableContainer.querySelectorAll(
      ".jventryDataTableBodyStyletr"
    );

    // Check if the row at the specified index exists
    if (rows[rowIndex]) {
      // Each .jventryDataTableBodyStyletr is a flex div with two children:
      //   [0] = data row div (contains SI No div + column divs)
      //   [1] = spacer div
      const dataRowDiv = rows[rowIndex]?.children[0];
      if (dataRowDiv) {
        // children of dataRowDiv: [0]=SINo, [1..N]=column divs
        const nextColumnIndex =
          Number(columnIndex) - 1 < dataRowDiv.children.length - 1
            ? Number(columnIndex)
            : 0;
        const nextInput = dataRowDiv.children[nextColumnIndex]?.querySelector("input");
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
    sessionStorage.removeItem('journalEntryRowIndex');
    sessionStorage.removeItem('journalEntryColumnIndex');

  }
  // //////////////////console.log(RowIndex);

  const handleKeyDownTable = (event, rowIndex, columnIndex) => {
    if (event.key === "Enter" || event.key === "Return") {
      event.preventDefault();

      const tableContainer = tableContainerRef.current;
      const rows = tableContainer.querySelectorAll(
        ".jventryDataTableBodyStyletr"
      );

      // Check if the row at the specified index exists
      if (rows[rowIndex]) {
        // Each .jventryDataTableBodyStyletr is a flex div; first child is the data row div
        const dataRowDiv = rows[rowIndex]?.children[0];
        if (dataRowDiv) {
          // children of dataRowDiv: [0]=SINo, [1..N]=column divs
          const totalCols = dataRowDiv.children.length;
          const nextColumnIndex =
            columnIndex < totalCols - 1 ? columnIndex + 1 : 0;

          const nextInput = dataRowDiv.children[nextColumnIndex]?.querySelector("input");

          if (nextInput) {
            const currentInputAccno = columnIndex === 1;

            if (currentInputAccno && !event.target.value.trim()) {
              if (saveDisabled) {
                editButtonRef.current.focus();
              } else {
                saveButtonRef.current.focus();
              }
            } else {
              nextInput.focus();
            }
          }
        }
      }
    }

    setRowIndex(rowIndex);
  };

  /////////////////////////////////////////////

  useEffect(() => {

    fetchSchEntryno();
  }, [apiBaseUrl, fyid, dbCode]);

  const fetchSchEntryno = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(`${apiBaseUrl}/main/jv_entryno/${dbCode}/${fyid}`);
      // //////////////////console.log("response =", response);
      const schemeRecentryNo = response.data;

      setJvInfoData((prevData) => ({
        ...prevData,
        EntryNo: schemeRecentryNo,
      }));
    } catch (error) {
      console.error("Error fetching entry no:", error.message);
    }
  };



  //////////agent name///////////////

  const [agentName, setagentName] = useState([]);
  // const [agentobj, setAgentObj] = useState([]);

  useEffect(() => {


    fetchAgname();
  }, [apiBaseUrl, dbCode]);

  useEffect(() => {
    const fetchLocations = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/otherregistration/getoptions/${dbCode}`
        );
        const data = response.data || [];
        const filtered = data
          .filter((item) => String(item.Type || item.type || "").toLowerCase() === "location")
          .map((item) => [Number(item.Auto ?? item.auto ?? 0), item.Name || item.name]);
        setLocationOptions(filtered);

        if (filtered.length > 0) {
          const targetId = activeLocation?.id || storedLocId;
          const match = targetId ? filtered.find((l) => Number(l[0]) === Number(targetId)) : null;
          const chosen = match || filtered[0];
          setJvInfoData((prev) => {
            if (!prev.Location || !prev.Location[0] || prev.Location[0] === 0) {
              return { ...prev, Location: chosen };
            }
            return prev;
          });
        }
      } catch (error) {
        console.error("Error fetching location options:", error);
      }
    };
    fetchLocations();
  }, [apiBaseUrl, dbCode, activeLocation]);
  const fetchAgname = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(`${apiBaseUrl}/main/jvschsalesmanNames/${dbCode}`);

      // Assuming response.data is an array with objects and each object has a LedName property
      const AgName = response.data;

      // Transforming the array into the desired format
      // const supplName = cName.map((item) => item.LedName);

      const transformedData = AgName.map((item) => [item.Auto, item.Name]);
      setagentName(transformedData);

      // setsupplierName(supplName);
    } catch (error) {
      console.error("Error fetching agent Values:", error.message);
    }
  };

  // const fetchAgname = async (searchTerm = '') => {
  //   try {
  //     const response = await axios.get(`${apiBaseUrl}/main/jvschsalesmanNames?search=${encodeURIComponent(searchTerm)}`);
  //     const AgName = response.data;
  //     const transformedData = AgName.map((item) => [item.Auto, item.Name]);
  //     setagentName(transformedData);
  //   } catch (error) {
  //     console.error("Error fetching agent Values:", error.message);
  //   }
  // };
  // const handleAgentSearch = (searchTerm) => {
  //   fetchAgname(searchTerm);
  // };

  ////////////////////ledger/////////////////////

  const [LedgerName, setLedgerName] = useState([]);

  useEffect(() => {


    fetchLgname();


    // Connect to the WebSocket server
    const socket = io(apiBaseUrl); // Make sure the URL matches your backend server
    socket.on('dataUpdated', async () => {
      //   //////////////////console.log('Data updated, fetching new data...');
      await fetchLgname(); // Re-fetch the data when an update is detected
      backtrackfocus();


    });

    return () => {
      socket.disconnect(); // Clean up the socket connection on component unmount
      //   //////////////////console.log("socketdisconneccted");

    };

  }, [apiBaseUrl, dbCode]);

  const fetchLgname = async () => {
    if (!dbCode) return;
    try {
      const response = await axios.get(`${apiBaseUrl}/main/jvledgernames/${dbCode}`);

      // Assuming response.data is an array with objects and each object has a LedName property
      const LgName = response.data;

      // Transforming the array into the desired format
      // const supplName = cName.map((item) => item.LedName);

      const transformedData = LgName.map((item) => [
        item.Ledcode,
        item.LedName,
      ]);
      setLedgerName(transformedData);

      // setsupplierName(supplName);
    } catch (error) {
      console.error("Error fetching agent Values:", error.message);
    }

  };


  const handleCheckLedger = (e, rowIndex, columnIndex) => {
    // //////////////////console.log('regcustom',AcNames);
    // //////////////////console.log("index==",rowIndex,columnIndex);


    const targetValue = e.target.value;

    const isValuePresent = LedgerName.some((item) => item[1] === targetValue);

    if (!isValuePresent && e.target.value !== "") {

      if (!window.confirm("Ledger Does not Exists,Create New..?")) {

        return;

      }
      Open(e, rowIndex, columnIndex);
    }
  };



  ////////////////total calculations/////////////////////////////


  useEffect(() => {
    let totalAmount = 0;
    let totalGm = 0;
    tableData.forEach((rowData) => {
      totalAmount += parseFloat(rowData.amount || 0);
      totalGm += parseFloat(rowData.gm || 0);
    });
    setJvInfoData((prevState) => ({
      ...prevState,
      totalamt: totalAmount.toFixed(3), // Update total amount
      totalgm: totalGm.toFixed(3), // Update total gm
    }));
  }, [tableData]);

  ////////////////////

  const [comboValue, setComboValue] = useState("");
  const handleClearCombo = () => {
    setComboValue("");
  };
  ///////////////////////////////////clear/////////////////////////////

  const handleClear = () => {
    fetchSchEntryno();

    setJvInfoData({
      Location: getDefaultBranch(),
      Salesman: "",
      date: getCurrentDate(),
    });

    setTableData([
      ...Array(14).fill({
        SINo: "",
        debitAccount: "",
        creditAccount: "",
        amount: "",
        narration: "",
      }),
    ]);

    triggerInitialFocus();
    setRowIndex(0);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);

    // const [editDisabled, setEditDisabled] = useState(true);
    // const [deleteDisabled, setDeleteDisabled] = useState(true);
    // const [saveDisabled, setSaveDisabled] = useState(false);
  };

  const handleClearfind = () => {
    setJvInfoData({
      Location: getDefaultBranch(),
      Salesman: "",
      date: getCurrentDate(),
    });

    setTableData([
      ...Array(14).fill({
        SINo: "",
        debitAccount: "",
        creditAccount: "",
        amount: "",
        narration: "",
      }),
    ]);

    triggerInitialFocus();
    setRowIndex(0);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);

    // const [editDisabled, setEditDisabled] = useState(true);
    // const [deleteDisabled, setDeleteDisabled] = useState(true);
    // const [saveDisabled, setSaveDisabled] = useState(false);
  };
  ////////////////////////////////////////////////////////

  const handleSave = async () => {
    setSaveDisabled(true);

    try {
      if (jvInfoData.date && !isDateInFy(jvInfoData.date)) {
        alert("Date incompatible with financial year");
        setSaveDisabled(false);
        return;
      }

      const hasIncompleteData = tableData.some((row) => {
        return (
          Object.values(row).some((value) => value !== "") &&
          (!row.debitAccount || !row.creditAccount || !row.amount || !jvInfoData.Salesman)
        );
      });

      if (hasIncompleteData) {
        alert("Enter Data Correctly.");
        setSaveDisabled(false);
        return;
      }


      const hasData = tableData.some((row) => {
        return (
          row.debitAccount &&
          row.creditAccount &&
          row.amount &&
          Object.values(row).some((value) => value !== "")
        );
      });

      if (!hasData) {
        // If no data is entered, display an alert and return without saving
        alert("Enter Data  Correctly.");
        setSaveDisabled(false);

        return;
      }

      const filteredTableData = tableData.filter((row) => {
        // Check if any of the fields in the row is not empty
        return Object.values(row).some((value) => value !== "");
      });

      const transformedTableData = filteredTableData.map((row) => ({
        SINo: row.SINo || null,
        debitAccount: row.debitAccount[0] || null,
        creditAccount: row.creditAccount[0] || null,
        amount: parseInt(row.amount) || null,
        narration: row.narration || null,
      }));
      // //////////////////console.log("transformedTableData", transformedTableData);
      const response = await axios.post(`${apiBaseUrl}/main/savejournal/${dbCode}/${fyid}`, {
        Location: Number(
          jvInfoData.Location?.[0] ||
          activeLocation?.id ||
          sessionStorage.getItem("loginLocationId") ||
          0
        ),
        Salesman: jvInfoData.Salesman[0],
        date: jvInfoData.date,
        EntryNo: jvInfoData.EntryNo,
        totalAmount: jvInfoData.totalamt,
        type: transformedTableData, // Pass the entire tableData array
      });

      if (response.data.success) {
        handleClear();
        //  Swal.fire("Success", "Data saved successfully!", "success");

        alert("Entry Saved");

        // Optionally, you can perform additional actions after successful save
      } else {
        //Swal.fire("Error", "Failed to save data!", "error");
        // alert("Failed to save data!");
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      //  Swal.fire("Error", "Internal server error!", "error");
      alert("Internal server error!");
      setSaveDisabled(false);
    }
    // handleClear();
  };

  const handleEdit = async () => {
    try {

      const hasIncompleteData = tableData.some((row) => {
        return (
          Object.values(row).some((value) => value !== "") &&
          (!row.debitAccount || !row.creditAccount || !row.amount || !jvInfoData.Salesman)
        );
      });

      if (hasIncompleteData) {
        alert("Enter Data Correctly.");
        setSaveDisabled(false);
        return;
      }



      if (!jvInfoData.Location) {
        alert("Enter Data  Correctly.");
        return;
      }

      const hasData = tableData.some((row) => {
        return (
          row.debitAccount &&
          row.creditAccount &&
          row.amount &&
          Object.values(row).some((value) => value !== "")
        );
      });

      if (!hasData) {
        // If no data is entered, display an alert and return without saving

        alert("Enter Data  Correctly.");
        return;
      }

      const filteredTableData = tableData.filter((row) => {
        // Check if any of the fields in the row is not empty
        return Object.values(row).some((value) => value !== "");
      });

      const transformedTableData = filteredTableData.map((row) => ({
        SINo: row.SINo || null,
        debitAccount: row.debitAccount[0] || null,
        creditAccount: row.creditAccount[0] || null,
        amount: parseInt(row.amount) || null,
        narration: row.narration || null,
      }));
      ////////////////////console.log("transformedTableData", transformedTableData);
      const response = await axios.post(`${apiBaseUrl}/main/jvupdate/${dbCode}/${fyid}`, {
        Location: Number(
          jvInfoData.Location?.[0] ||
          activeLocation?.id ||
          sessionStorage.getItem("loginLocationId") ||
          0
        ),
        Salesman: jvInfoData.Salesman[0],
        date: jvInfoData.date,
        EntryNo: jvInfoData.EntryNo,
        type: transformedTableData, // Pass the entire tableData array
      });

      if (response.data.success) {
        //   handleClear();

        // Swal.fire("Success", "Data Edit successfully!", "success");

        alert("Entry Edited");
        // Optionally, you can perform additional actions after successful save
        triggerInitialFocus();
      } else {
        // Swal.fire("Error", "Failed to edit data!", "error");
        alert("Failed to edit data!");
      }
    } catch (error) {
      console.error("Error edit data:", error.message);
      // Swal.fire("Error", "Internal server error!", "error");
      alert("Internal server error!");
    }
    // handleClear();
  };


  ////////////////////console.log("datra",tableData[0].accountNumber);

  const [showFindDialog, setShowFindDialog] = useState(false); // State for controlling the visibility of the find dialog
  const [findEntryNo, setFindEntryNo] = useState(""); // State to store the entry number entered in the find dialog
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [selectedSlNo, setSelectedSlno] = useState("");

  // //////////////////console.log(findEntryNo);
  const openFindDialog = () => {
    setShowFindDialog(true);
  };

  const closeFindDialog = () => {
    setShowFindDialog(false);
    setFindEntryNo("");
  };

  const openPrintDialog = () => {
    setShowPrintDialog(true);
  };

  const closePrintDialog = () => {
    setShowPrintDialog(false);
  };

  const [firstEno, setFirstEno] = useState("");
  const [lastEno, setLastEno] = useState("");
  ////////////////////console.log(firstEno,lastEno);

  const fetchfirstandlast = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/main/jvtopandlast/${dbCode}/${fyid}`);
      if (response.status === 200) {
        setFirstEno(response.data[0].firstentryno);
        setLastEno(response.data[0].lastentryno);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  // //////////////////console.log('accNo==',accNo);
  // //////////////////console.log('accccc=',accNo.find((item) => item[0] === 10));

  const handleFindbyentrynumber = async () => {
    handleClearfind();
    try {
      const response = await axios.get(`${apiBaseUrl}/main/findjv/${findEntryNo}/${dbCode}/${fyid}`);

      if (response.status === 200) {
        const foundData = response.data;
        //   //////////////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setJvInfoData({
          ...jvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: firstRowData.EntryNo[0],
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });

        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.log("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  // //////////////////console.log('formatted date',formatDate);

  const handleDelete = async () => {
    if (!window.confirm("Do You Want To Delete..?")) {
      return;
    }
    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/deletejv/${jvInfoData.EntryNo}/${dbCode}/${fyid}?location=${jvInfoData.Location ? jvInfoData.Location[0] : 0}`
      );
      if (response.status === 200) {
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Scheme deleted",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
        alert("Entry Deleted Successfully!");
        // window.location.reload();
        handleClear();
      } else {
        console.error("Error deleting data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleFindprev = async (e) => {
    fetchfirstandlast();
    if (jvInfoData.EntryNo > firstEno) {
      handleClearfind();
    }
    // else{
    //   return;
    // }
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/jvprevs/${jvInfoData.EntryNo}/${dbCode}/${fyid}`
      );

      //  //////////////////console.log("response=",response.data);
      if (response.status === 200) {
        const foundData = response.data;
        ////////////////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setJvInfoData({
          ...jvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: firstRowData.EntryNo[0],
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  const handleFindnext = async () => {
    fetchfirstandlast();
    if (jvInfoData.EntryNo < lastEno) {
      handleClearfind();
    }

    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/jvnext/${jvInfoData.EntryNo}/${dbCode}/${fyid}`
      );

      if (response.status === 200) {
        const foundData = response.data;
        ////////////////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setJvInfoData({
          ...jvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: firstRowData.EntryNo[0],
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };

  const handleFindfirst = async () => {
    handleClearfind();
    try {
      const response = await axios.get(`${apiBaseUrl}/main/jvfirst/${dbCode}/${fyid}`);

      if (response.status === 200) {
        const foundData = response.data;
        //  //////////////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setJvInfoData({
          ...jvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: firstRowData.EntryNo[0],
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };

  const handleFindlast = async () => {
    handleClearfind();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/jvlast/${dbCode}/${fyid}`
      );

      if (response.status === 200) {
        const foundData = response.data;
        ////////////////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration,
        }));

        const firstRowData = foundData[0]; // SrInfo data is the same for all rows
        setJvInfoData({
          ...jvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: firstRowData.EntryNo[0],
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,


        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  const handleCheckSlno = () => {
    const filteredTableData = tableData.filter((row) => {
      // Check if any of the fields in the row is not empty
      return Object.values(row).some((value) => value !== "");
    });
    const filteredTableDataLength = filteredTableData.length;
    return filteredTableDataLength;
  };

  const [accumulatedWt, setaccumulatedWt] = useState("");
  ///////console.log("accumulatedWt",accumulatedWt);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/totalweight/${tableData[selectedSlNo - 1 || 0].name[0]}/${dbCode}`
      );
      ////////////////////console.log("res===",response.data);
      setaccumulatedWt(response.data[0].WeightDifference);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      localStorage.removeItem(`grid_design_${vType}`);
      localStorage.removeItem(`form_design_${vType}`);
      const response = await axios.get(
        `${apiBaseUrl}/main/griddesign/${dbCode}/${vType}`,
      );
      const dbCols = response.data.recordset || response.data || [];
      if (dbCols.length > 0) {
        const merged = defaultJournalGridColumns.map((initCol) => {
          const dbMatch = dbCols.find(
            (c) =>
              String(c.ColName).toLowerCase() ===
              String(initCol.columnName).toLowerCase(),
          );
          if (dbMatch) {
            return {
              ...initCol,
              width: dbMatch.Width !== null ? dbMatch.Width : initCol.width,
              orderNo: dbMatch.InNo !== null ? dbMatch.InNo : initCol.orderNo,
              header: dbMatch.Header || initCol.header,
              show: dbMatch.Vis === 1,
            };
          }
          return initCol;
        });
        merged.sort((a, b) => a.orderNo - b.orderNo);
        localStorage.setItem(`grid_design_${vType}`, JSON.stringify(merged));
        setGridColumns(merged);
      } else {
        setGridColumns(defaultJournalGridColumns);
      }
    } catch (error) {
      console.error("Error refreshing grid settings:", error);
    }
    handleClear();
    setTimeout(() => {
      setIsRefreshing(false);
    }, 600);
  };

  return (
    <div
      className="bg-white
        font-Poppins
        w-[60%]
        h-[77%]
        lg:w-[850px]
        lg:h-[480px]
        rounded-[10px]
        shadow-md
        flex
        flex-col
        items-center
        absolute
        transition-all
        duration-300"
      style={{ zIndex }}
    >
      <WindowHeader
        title="Journal Entry"
        logo={headeLogo}
        onClose={onClose}
        style={{ height: "30px" }}
        className="bg-[#0f56d3] text-white"
        titleClassName="text-xs"
        closeBtnClassName="w-6 h-6 rounded-[5px] border-none mr-2 flex items-center justify-center"
      />

        {/* ActionToolbar */}
        <ActionToolbar
          width="100%"
          height="auto"
          size="small"
          iconSize={14}
          navBgColor="#0f56d3"
          navIconColor="#ffffff"
          buttonGap="5px"
          saveBtnId="SaveBtn"
          printBtnId="PrintBtn"
          clearBtnId="ClearBtn"
          findBtnId="FindBtn"
          editBtnId="EditBtn"
          deleteBtnId="DeleteBtn"
          exitBtnId="ExitBtn"
          showSave={isFieldVisible("SaveBtn")}
          showPrint={isFieldVisible("PrintBtn")}
          showClear={isFieldVisible("ClearBtn")}
          showFind={isFieldVisible("FindBtn")}
          showEdit={isFieldVisible("EditBtn")}
          showDelete={isFieldVisible("DeleteBtn")}
          showExit={isFieldVisible("ExitBtn")}
          saveDisabled={isFieldDisabled("SaveBtn") || saveDisabled}
          editDisabled={isFieldDisabled("EditBtn") || editDisabled}
          deleteDisabled={isFieldDisabled("DeleteBtn") || deleteDisabled}
          findDisabled={isFieldDisabled("FindBtn")}
          dataFound={!editDisabled}
          onSave={handleSave}
          onPrint={openPrintDialog}
          onClear={handleClear}
          onFind={openFindDialog}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onExit={onClose}
          onFirst={handleFindfirst}
          onPrevious={handleFindprev}
          onNext={handleFindnext}
          onLast={handleFindlast}
          permissions={permissions["jvEntry"]}
          showSettingsBar={true}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          settingsOptions={[
            {
              label: "Design Columns",
              onClick: () => setShowGridDesignModal(true),
            },
            {
              label: "Design Form",
              onClick: () => setShowFormDesignModal(true),
            },
          ]}
          onRefsUpdate={(refs) => {
            if (refs.saveButtonRef && refs.saveButtonRef.current) {
              saveButtonRef.current = refs.saveButtonRef.current;
              registerRef("SaveBtn")(refs.saveButtonRef.current);
            }
            if (refs.editButtonRef && refs.editButtonRef.current) {
              editButtonRef.current = refs.editButtonRef.current;
              registerRef("EditBtn")(refs.editButtonRef.current);
            }
          }}
        />

      <div className="jventryBody">
        <div className="jventryBodyData">
          <div className="jventryTopdata">
            <div className="jventryTopdatasections jventrysec1">
              {isFieldVisible("EntryNo") && (
                <div className="jventryTopdatasectionsrows" style={getContainerStyle("EntryNo")}>
                  <label style={getLabelStyle("EntryNo")}>Entry No</label>
                  <input
                    id="EntryNo"
                    ref={registerRef("EntryNo")}
                    readOnly
                    disabled={isFieldDisabled("EntryNo")}
                    style={{ textAlign: "center", ...getInputStyle("EntryNo") }}
                    value={jvInfoData.EntryNo}
                    onKeyDown={(e) => handleDynamicKeyDown(e, "EntryNo")}
                    onChange={(e) =>
                      setJvInfoData({
                        ...jvInfoData,
                        EntryNo: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              <div className="jventryTopdatasectionsrows"></div>
            </div>
            <div className="jventryTopdatasections jventrysec2">
              {isFieldVisible("Branch") && (
                <div className="jventryTopdatasectionsrows sec2row" style={getContainerStyle("Branch")}>
                  <label style={getLabelStyle("Branch")}>Select Branch</label>
                  <ComboBox
                    id="Branch"
                    findedValue={
                      Array.isArray(jvInfoData.Location)
                        ? jvInfoData.Location[1]
                        : jvInfoData.Location
                    }
                    comboRef={registerRef("Branch")}
                    disabled={isFieldDisabled("Branch")}
                    readOnly={isFieldReadOnly("Branch")}
                    options={locationOptions}
                    className="cashaccCombo"
                    inputClassName="cashaccComboinput"
                    onKeyDown={(e) => {
                      handleDynamicKeyDown(e, "Branch");
                    }}
                    onInputChange={(e) =>
                      setJvInfoData({ ...jvInfoData, Location: e })
                    }
                  />
                </div>
              )}
              {isFieldVisible("Salesman") && (
                <div className="jventryTopdatasectionsrows sec2row" style={getContainerStyle("Salesman")}>
                  <label style={getLabelStyle("Salesman")}>Select Salesman</label>
                  <ComboBox
                    id="Salesman"
                    findedValue={
                      Array.isArray(jvInfoData.Salesman)
                        ? jvInfoData.Salesman[1]
                        : jvInfoData.Salesman
                    }
                    comboRef={registerRef("Salesman")}
                    disabled={isFieldDisabled("Salesman")}
                    readOnly={isFieldReadOnly("Salesman")}
                    options={agentName}
                    className="cashaccCombo"
                    inputClassName="cashaccComboinput"
                    onKeyDown={(e) => {
                      handleDynamicKeyDown(e, "Salesman");
                    }}
                    onInputChange={(e) => {
                      setJvInfoData({ ...jvInfoData, Salesman: e });
                    }}
                  />
                </div>
              )}
            </div>
            <div className="jventryTopdatasections  jventrySec3">
              {isFieldVisible("Date") && (
                <div
                  className="jventryTopdatasectionsrows sec3row"
                  style={{ width: "14vw", ...getContainerStyle("Date") }}
                >
                  <label style={getLabelStyle("Date")}>Date</label>
                  <input
                    id="Date"
                    value={jvInfoData.date}
                    type="date"
                    min={minDate}
                    max={maxDate}
                    ref={registerRef("Date")}
                    disabled={isFieldDisabled("Date")}
                    readOnly={isFieldReadOnly("Date")}
                    style={getInputStyle("Date")}
                    onKeyDown={(e) => handleDynamicKeyDown(e, "Date")}
                    onChange={(e) => {
                      setJvInfoData({
                        ...jvInfoData,
                        date: e.target.value,
                      });
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      if (val && !isDateInFy(val)) {
                        alert("Date incompatible with financial year");
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {/*---------------- receipt data table.----------------------- */}

          <div
            className="jventryDataTable"
            ref={tableContainerRef}
          >
            {/* ── Header ── */}
            <div className="w-max min-w-full flex sticky z-30 top-0">
              <div className="w-max min-w-full h-[1.5rem] bg-[#026CC3] flex">
                {/* SI No header */}
                <div
                  style={{ width: 50, flexShrink: 0 }}
                  className="h-full jvTableColBorder flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                >
                  SI No
                </div>
                {gridColumns.map((col) => {
                  if (!col.show) return null;
                  return (
                    <div
                      key={col.columnName}
                      style={{ width: `${col.width}px`, flexShrink: 0 }}
                      className="h-full jvTableColBorder flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                    >
                      {col.header}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ── Body ── */}
            <div className="w-full h-max flex flex-col">
              {tableData.map((rowData, rowIndex) => {
                const handleGridKeyDown = createGridKeyDownHandler({
                  rowIndex, breakoutColumn, rowBreakColumn, rowBreakTarget,
                  formFields, addRow, focusField, handleDynamicKeyDown,
                });

                return (
                  <div
                    key={rowIndex}
                    className="jventryDataTableBodyStyletr w-max min-w-full h-[3rem] bg-white flex flex-col"
                  >
                    {/* ── Top half: input fields ── */}
                    <div className="w-max min-w-full h-1/2 bg-white flex">
                      {/* SI No cell */}
                      <div
                        className="h-full jvTableColBorder flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center text-black"
                        style={{ width: 50, flexShrink: 0 }}
                      >
                        {rowIndex + 1}
                      </div>
                      {gridColumns
                        .filter((c) => c.show)
                        .map((col, visibleIndex) => {
                          const DOMIndex = visibleIndex + 1;
                          const colStyle = { width: `${col.width}px`, flexShrink: 0 };
                          const cellClass = "h-full jvTableColBorder flex items-center font-inter text-xs";

                          const renderCell = {
                            debitAccount: () => (
                              <div key={col.columnName} style={colStyle} className={cellClass}>
                                <ComboBox
                                  id={`grid_${rowIndex}_debitAccount`}
                                  findedValue={
                                    Array.isArray(tableData[rowIndex]?.debitAccount)
                                      ? tableData[rowIndex]?.debitAccount?.[1] ?? ""
                                      : tableData[rowIndex]?.debitAccount
                                  }
                                  options={LedgerName}
                                  className="jventryDataTableDataBox test"
                                  inputClassName="dataBox"
                                  comboRef={registerRef(`grid_${rowIndex}_debitAccount`)}
                                  onKeyDown={(e) => handleGridKeyDown(e, "debitAccount")}
                                  onInputChange={(e) => handleCellChange(e, rowIndex, "debitAccount")}
                                  onBlur={(e) => handleCheckLedger(e, rowIndex, DOMIndex)}
                                />
                              </div>
                            ),
                            creditAccount: () => (
                              <div key={col.columnName} style={colStyle} className={cellClass}>
                                <ComboBox
                                  id={`grid_${rowIndex}_creditAccount`}
                                  findedValue={
                                    Array.isArray(tableData[rowIndex]?.creditAccount)
                                      ? tableData[rowIndex]?.creditAccount?.[1] ?? ""
                                      : tableData[rowIndex]?.creditAccount
                                  }
                                  options={LedgerName}
                                  className="jventryDataTableDataBox test"
                                  inputClassName="dataBox"
                                  comboRef={registerRef(`grid_${rowIndex}_creditAccount`)}
                                  onKeyDown={(e) => handleGridKeyDown(e, "creditAccount")}
                                  onInputChange={(e) => handleCellChange(e, rowIndex, "creditAccount")}
                                  onBlur={(e) => handleCheckLedger(e, rowIndex, DOMIndex)}
                                />
                              </div>
                            ),
                            amount: () => (
                              <div key={col.columnName} style={colStyle} className={cellClass}>
                                <input
                                  id={`grid_${rowIndex}_amount`}
                                  value={tableData[rowIndex]?.amount || ""}
                                  className="font-Inter h-[95%] w-full border-none p-0 m-0 text-right text-black text-xs"
                                  ref={registerRef(`grid_${rowIndex}_amount`)}
                                  onChange={(e) => handleCellChangeinput(e, rowIndex, "amount")}
                                  onKeyDown={(e) => handleGridKeyDown(e, "amount")}
                                  type="number"
                                />
                              </div>
                            ),
                            narration: () => (
                              <div key={col.columnName} style={colStyle} className={cellClass}>
                                <input
                                  id={`grid_${rowIndex}_narration`}
                                  value={tableData[rowIndex]?.narration || ""}
                                  className="font-Inter h-[95%] w-full border-none p-0 m-0 text-black text-xs"
                                  ref={registerRef(`grid_${rowIndex}_narration`)}
                                  onKeyDown={(e) => handleGridKeyDown(e, "narration")}
                                  onChange={(e) => handleCellChangeinput(e, rowIndex, "narration")}
                                />
                              </div>
                            ),
                          };

                          const renderer = renderCell[col.columnName];
                          if (renderer) return renderer();
                          return <div key={col.columnName} style={colStyle} className="h-full jvTableColBorder" />;
                        })}
                    </div>

                    {/* ── Bottom half: secondary row (EBEBEB) ── */}
                    <div className="w-max min-w-full h-1/2 bg-[#EBEBEB] flex">
                      <div style={{ width: 50, flexShrink: 0 }} className="h-full" />
                      {gridColumns.filter((c) => c.show).map((col) => (
                        <div
                          key={col.columnName}
                          style={{ width: `${col.width}px`, flexShrink: 0 }}
                          className="h-full"
                        />
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* ── Footer ── */}
            <div className="w-max min-w-full h-[26px] bg-[#026cc3] flex text-[10px] font-semibold leading-normal text-white sticky bottom-0 z-30">
              {/* SI No footer cell */}
              <div
                style={{ width: 50, flexShrink: 0 }}
                className="h-full jvTableColBorder flex items-center justify-center"
              />
              {gridColumns.filter((c) => c.show).map((col) => {
                if (col.columnName === "amount") {
                  return (
                    <div
                      key={col.columnName}
                      style={{ width: `${col.width}px`, flexShrink: 0 }}
                      className="h-full jvTableColBorder flex items-center justify-end px-1"
                    >
                      <input
                        value={jvInfoData.totalamt}
                        style={{
                          textAlign: "right",
                          width: "100%",
                          height: "22px",
                          border: "none",
                          background: "white",
                          paddingRight: "4px",
                          boxSizing: "border-box",
                          color: "#000",
                          fontSize: "10px",
                        }}
                        readOnly
                      />
                    </div>
                  );
                }
                return (
                  <div
                    key={col.columnName}
                    style={{ width: `${col.width}px`, flexShrink: 0 }}
                    className="h-full jvTableColBorder"
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {showFindDialog && (
        <div className="find-dialog">
          <input
            type="text"
            value={findEntryNo}
            onChange={(e) => setFindEntryNo(e.target.value)}
            placeholder="Enter Entry No"
          />
          <button onClick={handleFindbyentrynumber}>Find</button>
          {/* <button
            onClick={() => {
              closeFindDialog();
              handleClear();
            }}
          >
            Cancel
          </button> */}
          <div
            className="findCloseDiv"
            onClick={() => {
              closeFindDialog();
              handleClear();
            }}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <img
              src={close}
              alt="Close"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}

      {showPrintDialog && (
        <div className="find-dialog">
          <input
            type="text"
            // value={findEntryNo}
            onChange={(e) => setSelectedSlno(e.target.value)}
            placeholder="Enter Sl No"
          />
          <button onClick={openPrintModal}>Print</button>
          <div
            className="findCloseDiv"
            onClick={() => {
              closePrintDialog();
              handleClear();
            }}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <img
              src={close}
              alt="Close"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}
      {showPrintModel && (
        <Print
          printData={printData}
          onClose={handleClosePrint}
          totalwt={accumulatedWt}
        />
      )}
      {showGridDesignModal && (
        <GridDesign
          onClose={() => setShowGridDesignModal(false)}
          onSave={(columns) => {
            setGridColumns(columns);
            localStorage.setItem(`grid_design_${vType}`, JSON.stringify(columns));
            setShowGridDesignModal(false);
          }}
          formName={vType}
          initialColumns={defaultJournalGridColumns}
        />
      )}
      {showFormDesignModal && (
        <FormDesign
          onClose={() => setShowFormDesignModal(false)}
          formName={vType}
          initialFields={defaultJournalFormFields}
          zIndex={zIndex}
          highlightFieldId={activeFieldId}
          onSave={(updatedFields) => {
            setFormFields(updatedFields);
          }}
        />
      )}
    </div>
    // </div>
  );
}

const defaultJournalFormFields = [
  // ── Header Fields ──
  {
    fieldId: "EntryNo",
    fieldName: "Entry No",
    tabIndex: 0,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Branch",
    fieldName: "Select Branch",
    tabIndex: 1,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Salesman",
    fieldName: "Select Salesman",
    tabIndex: 2,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Date",
    fieldName: "Date",
    tabIndex: 3,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Date",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Grid ──
  {
    fieldId: "Grid",
    fieldName: "Journal Grid",
    tabIndex: 4,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Grid",
  },
  // ── Grid Inputs ──
  {
    fieldId: "grid_debitAccount",
    fieldName: "Grid - Select Debit Account",
    tabIndex: 5,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
  },
  {
    fieldId: "grid_creditAccount",
    fieldName: "Grid - Select Credit Account",
    tabIndex: 6,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
  },
  {
    fieldId: "grid_amount",
    fieldName: "Grid - Amount",
    tabIndex: 7,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_narration",
    fieldName: "Grid - Narration",
    tabIndex: 8,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
  },
  // ── Action Toolbar Buttons ──
  {
    fieldId: "SaveBtn",
    fieldName: "Save",
    tabIndex: 9,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PrintBtn",
    fieldName: "Print",
    tabIndex: 10,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ClearBtn",
    fieldName: "Clear",
    tabIndex: 11,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "FindBtn",
    fieldName: "Find",
    tabIndex: 12,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "EditBtn",
    fieldName: "Edit",
    tabIndex: 13,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "DeleteBtn",
    fieldName: "Delete",
    tabIndex: 14,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExitBtn",
    fieldName: "Exit",
    tabIndex: 15,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Breakout / Row-Break Config Pseudo-Fields ──
  {
    fieldId: "__GridBreakoutColumn",
    fieldName: "Grid Breakout Column",
    tabIndex: 9999,
    defaultValue: "debitAccount",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridBreakoutTarget",
    fieldName: "Grid Breakout Target",
    tabIndex: 9999,
    defaultValue: "SaveBtn",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakColumn",
    fieldName: "Grid Row-Break Column",
    tabIndex: 9999,
    defaultValue: "narration",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakTarget",
    fieldName: "Grid Row-Break Target",
    tabIndex: 9999,
    defaultValue: "debitAccount",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
];

function JournalEntry(props) {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const vType = props.voucherType || props.formName || "JOURNAL";

  return (
    <FormDesignProvider
      formName={vType}
      defaultFields={defaultJournalFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <JournalEntryInner {...props} />
    </FormDesignProvider>
  );
}

export default JournalEntry;
